import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'ui-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss'],
})
export class InputComponent implements OnInit {
  @Input() public type: 'text' | 'password' | 'email' = 'text';
  @Input() public control: FormControl<string | null> = new FormControl<string>(
    '',
  );
  @Input() public label = '';
  @Input() public placeholder = '';
  @Input() public isDisabled = false;
  @Input() public isMaterialLabel = true;
  @Input() public hideReveal = false;
  @Input() public inputId = '';
  @Input() public autocomplete: 'on' | 'off' = 'on';
  @Input() public hint = '';
  @Input() public mask: unknown = null;

  public initialType: 'text' | 'password' | 'email' = 'text';

  public ngOnInit(): void {
    this.initialType = this.type;

    if (this.isDisabled) {
      this.control.disable();
    }
  }

  public toggleInputType($event: MouseEvent): void {
    this.type = this.type === 'password' ? 'text' : 'password';
    $event.stopPropagation();
    $event.preventDefault();
  }

  public valueChanged(): void {
    this.control.markAsTouched();
    this.control.markAsDirty();
    this.control.updateValueAndValidity();
  }
}
